import { useLayoutEffect, useRef, useState } from "react";
import type { ReactNode } from "react";

/** 预留表头 + 分页 + 表体与容器间距（约值，避免整块被撑出视口） */
const TABLE_CHROME_RESERVE_PX = 132;

/**
 * 占满主内容区剩余高度，将测得高度交给表格 `scroll.y`，仅表体滚动。
 */
export function LedgerTableViewport({
  children,
}: {
  children: (tableBodyMaxHeight: number) => ReactNode;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [bodyY, setBodyY] = useState(320);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const measure = () => {
      const h = Math.floor(el.getBoundingClientRect().height);
      setBodyY(Math.max(160, h - TABLE_CHROME_RESERVE_PX));
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <div className="admin-ledger-table-viewport">
      <div ref={ref} className="admin-ledger-table-measure">
        {children(bodyY)}
      </div>
    </div>
  );
}
